export const ipsIds = {
  "8d47ae32-912a-476f-929a-9d0d73ed3b9c": "NOX_LUXURY_SLEEP",
  "cdb54b4e-f9fc-4ca6-8850-e818e693789c": "HOSPITAL_REGIONAL_DE_SOGAMOSO",
};
